import moment from 'moment';
import { FieldActionOnValuesFunction } from '../types';
import { SelectInputOptions } from '../../components/input/selectInput/types';
import { RenewRspConfirmationModel } from '../../api/models/renewRsp/RenewRspConfirmationModel';

export const financialYearOptions = (_values: Partial<RenewRspConfirmationModel>) => {
    const dateNow = moment().startOf('day').toDate();

    const yearCurrent = dateNow.getFullYear();
    const yearMinusOne = yearCurrent - 1;
    const yearPlusOne = yearCurrent + 1;
    const yearCurrentShort = yearCurrent.toString().substr(-2);
    const yearPlusOneShort = yearPlusOne.toString().substr(-2);

    const finYearOneValue = `${yearMinusOne}-${yearCurrent}`;
    const finYearTwoValue = `${yearCurrent}-${yearPlusOne}`;
    const finYearOne = `${yearMinusOne}/${yearCurrentShort}`;
    const finYearTwo = `${yearCurrent}/${yearPlusOneShort}`;

    const optionValues: SelectInputOptions[] = [
        { value: ``, label: `` },
        { value: `${finYearTwoValue}`, label: `${finYearTwo}` },
        { value: `${finYearOneValue}`, label: `${finYearOne}` },
    ];

    return optionValues;
};

const applicationFinancialYear: FieldActionOnValuesFunction<RenewRspConfirmationModel> = {
    financialYear: financialYearOptions,
};

export default applicationFinancialYear;
